<template>
  <CContainer fluid>
    <div class="metro-menu">
      <div 
        class="tile small bg-s3yellow" 
        @click="() => $router.push({ path: '/administracion/movimientos/clientes/cotizaciones' })">
        <i class="bi bi-file-earmark-text"></i>
        <span>Cotizaciones</span>
      </div>
      <div 
        class="tile small bg-s3green" 
        @click="() => $router.push({ path: '/administracion/movimientos/clientes/pedidos' })">
        <i class="bi bi-clipboard-check"></i>
        <span>Pedidos</span>
      </div>
      <div 
        class="tile small bg-s3purple" 
        @click="() => $router.push({ path: '/administracion/movimientos/clientes/entregasmercancia' })">
        <i class="bi bi-truck"></i>
        <span>Entregas de Mercanc&iacute;a</span>
      </div>
      <div 
        class="tile small bg-s3lime"
        @click="() => $router.push({ path: '/administracion/movimientos/clientes/facturasventa' })">
        <i class="bi bi-receipt-cutoff"></i>
        <span>Facturas de Venta</span>
      </div>
      <div 
        class="tile small bg-s3orange" 
        @click="() => $router.push({ path: '/administracion/movimientos/clientes/garantias' })">
        <i class="bi bi-award"></i>
        <span>Garant&iacute;as</span>
      </div>
      <div 
        class="tile small bg-s3darkgrey" 
        @click="() => $router.push({ path: '/administracion/movimientos/clientes/contratosarrendamientos' })">
        <i class="bi bi-file-earmark-medical"></i>
        <span>Contratos de Arrendamiento</span>
      </div>
      <div 
        class="tile medium bg-primary" 
        @click="() => $router.push({ path: '/administracion/movimientos/clientes/controldocumentoselectronicosventa' })">
        <i class="bi bi-filetype-xml"></i>
        <span>Documentos Electr&oacute;nicos de Venta</span>
      </div>
      <div class="tile small bg-info"
        @click="(e) => {
          e.preventDefault()
          e.stopPropagation();
          $router.push({ path: '/administracion/movimientos/clientes/controlseguimientodocumentos' });
        }">
        <i class="bi bi-geo-alt"></i>
        <span>Seguimiento de Entregas</span>
      </div>
      
      <!-- <div class="tile tile-6 small"><i class="fas fa-folder-open"></i><span>Archivos</span></div>
      <div class="tile tile-7 medium"><i class="fas fa-calendar"></i><span>Calendario</span></div>
      <div class="tile tile-8 small"><i class="fas fa-sign-out-alt"></i><span>Salir</span></div>
      <div class="tile tile-9 small"><i class="bi bi-gear"></i><span>Opciones</span></div>
      <div class="tile tile-10 medium"><i class=""></i><span>Notificaciones</span></div>
      <div class="tile tile-11 small"><i class="bi bi-camera"></i><span>Cámara</span></div>
      <div class="tile tile-12 medium"><i class="bi bi-music-note-list"></i><span>Música</span></div>
      <div class="tile tile-13 small"><i class=""></i><span>Contactos</span></div>
      <div class="tile tile-14 small"><i class="bi bi-cloud"></i><span>Nube</span></div>
      <div class="tile tile-15 large"><i class="bi bi-cpu"></i><span>Sistema</span></div>
      <div class="tile tile-16 small"><i class="bi bi-briefcase"></i><span>Trabajo</span></div>
      <div class="tile tile-17 medium"><i class="bi bi-map"></i><span>Mapa</span></div>
      <div class="tile tile-18 small"><i class="bi bi-lightbulb"></i><span>Ideas</span></div>
      <div class="tile tile-19 small"><i class="bi bi-book"></i><span>Libros</span></div>
      <div class="tile tile-20 medium"><i class="bi bi-film"></i><span>Videos</span></div> -->
    </div>
  </CContainer>
</template>

<style>
  @import "../../assets/css/metro-menu.css";
</style>

<script>
export default {
  name: "SalesMenu",
  components: {
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
  }
}
</script>